import { gql } from '@apollo/client';
import { AccountCreditCardInfoShared, ErrorMessageInfo } from '../fragments';

export default gql`
  mutation createAccountCreditCard($input: AccountCreditCardCreateInput!) {
    createAccountCreditCard(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      accountCreditCard {
        ...AccountCreditCardInfoShared
      }
    }
  }
  ${AccountCreditCardInfoShared}
  ${ErrorMessageInfo}
`;
